import {COMPLIMENT_INFO, COMPLIMENT_INFO_FILLED, SCENES} from "./mock";
import APP_SETTINGS from "../../config/settings";

const DEFAULT_STATE = {
    complimentInfo: APP_SETTINGS.DEBUG ? {...COMPLIMENT_INFO_FILLED} : {...COMPLIMENT_INFO},
    complimentCurrentStep: 0,
    complimentScene: SCENES.STEPPER
};

export default DEFAULT_STATE;